import { useLang } from 'hooks/lang';

import { FullProject, projectStatusByCode, taskStatusByCode, TaskWithSub } from 'entities';

import { FolderIcon, TaskIcon } from 'components/Icons';

import { ProjectOrTask } from './ProjectOrTask';
import { ItemGroup } from '../ItemGroup';

import { useUserEntries } from './userEntries.hook';

import { verifyHasExpiredDate, verifyIsExpiredDate } from './utils';
import { useUser } from 'hooks';

export function MyProjects() {
  const { t } = useLang();
  const user = useUser();

  const { projects, tasks } = useUserEntries();

  const shouldDisplayProjects = user.team.canAssumeProject;

  return (
    <>
      {!!projects.length && (
        <ItemGroup<FullProject | TaskWithSub>
          name={t('my-projects')}
          icon={<FolderIcon size={22} />}
          items={projects}
          itemKey="id"
          addErrorIndication={
            verifyHasExpiredDate(projects) ||
            projects.some(
              ({ activeIssues, ...p }) => !!activeIssues || verifyHasExpiredDate(p.tasks),
            )
          }
          render={(entry) => (
            <ProjectOrTask
              shouldDisplayProjects={shouldDisplayProjects}
              getStatusColor={(status) => projectStatusByCode[status].color}
              entry={entry}
              addErrorIndicator={
                verifyIsExpiredDate(entry) || !!(entry as FullProject).activeIssues
              }
            />
          )}
        />
      )}

      {!!tasks.length && (
        <ItemGroup<FullProject | TaskWithSub>
          name={t('my-tasks')}
          icon={<TaskIcon size={22} />}
          items={tasks}
          itemKey="id"
          addErrorIndication={verifyHasExpiredDate(tasks)}
          render={(entry) => (
            <ProjectOrTask
              shouldDisplayProjects={false}
              getStatusColor={(status) => taskStatusByCode[status].color}
              entry={entry}
              addErrorIndicator={
                verifyIsExpiredDate(entry) || !!(entry as FullProject).activeIssues
              }
            />
          )}
        />
      )}
    </>
  );
}
